import { Box } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { abbreviatedNumber } from 'src/pages/Yearbooks/presentation/components/Charts/utils';

import { CHART_COLORS } from '../../../constants';

interface LineColumnSeries {
  name: string;
  type: 'column' | 'line';
  data: (number | null)[];
}

interface LineColumnChartProps {
  series: LineColumnSeries[];
  categories: string[];
  height?: number;
}

export default function LineColumnChart({
  series,
  categories,
  height = 300,
}: LineColumnChartProps) {
  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <ReactApexChart
        type="line"
        series={series}
        height={height}
        width="100%"
        options={{
          chart: {
            type: 'line',
            stacked: false,
            toolbar: { show: false },
            background: 'transparent',
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 500,
            },
          },
          dataLabels: { enabled: false },
          stroke: {
            width: [0, 4],
            curve: 'smooth',
          },
          fill: {
            opacity: [0.85, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: 'vertical',
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100],
            },
          },
          tooltip: {
            theme: 'dark',
            y: {
              formatter: function (value: number | null, opts: unknown) {
                if (value == null || !Number.isFinite(value)) {
                  return '-';
                }

                const seriesIndex =
                  (opts as { seriesIndex?: number })?.seriesIndex ?? 0;
                if (seriesIndex === 1) {
                  return value.toLocaleString('pt-BR', {
                    maximumFractionDigits: 0,
                  });
                }
                return `R$ ${abbreviatedNumber(value)}`;
              },
            },
          },
          colors: CHART_COLORS,
          legend: { show: false },
          grid: { show: false },
          markers: { size: 0 },
          xaxis: {
            categories,
            type: 'category',
            labels: {
              style: { fontWeight: 'bold', colors: '#ADB2B1' },
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
          },
          yaxis: [
            { labels: { show: false }, min: 0 },
            { opposite: true, labels: { show: false } },
          ],
          responsive: [
            {
              breakpoint: 600,
              options: { chart: { animations: { enabled: false } } },
            },
          ],
        }}
      />
    </Box>
  );
}
